import { render, staticRenderFns } from "./ViewBusiness.vue?vue&type=template&id=a6996684&scoped=true"
import script from "./ViewBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusiness.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewBusiness.vue?vue&type=style&index=0&id=a6996684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6996684",
  null
  
)

export default component.exports